<!-- @format -->

<template>
	<van-action-sheet 
		v-model="show" 
		title="临床诊断"
		position="bottom" 
		:style="{height: '40vh'}"
	>
		<div class="cont">
			<van-field
				v-model="inputVal"
				:disabled="isView"
				rows="5"
				autosize
				type="textarea"
				maxlength="200"
				placeholder="请输入临床诊断"
			/>
			<van-button v-if="!isView" class="bottom-btn" type="primary" block @click="save">
				保存
			</van-button>
		</div>
	</van-action-sheet>
</template>

<script>
	export default {
		props:{
			value:{
				type:String,
				default:""
			},
			isView:{
				type:Boolean,
				default:false
			}
		},
	    data () {
	        return {
				show:false,
				diagnoseValue:'',
				finalVal:''
	        }
	    },

	    computed: {
			inputVal:{
				get(){
					return this.value
				},
				set(val){
					this.finalVal = val
				}
			}
	    },

	    created() {

	    },

	    methods: {
			save(){
				this.show = false
				this.$emit('input',this.finalVal)
			}
	    }
	}
</script>

<style lang="less" scoped>
	.cont{
		padding:30px;
		font-size: 30px;
		line-height: 60px;
		background-color: #fff;
		box-sizing: border-box;
	}
	.van-field {
        background-color: #F5F6F7;
        height: 250px;
        border-radius: 6px;
		padding: 24px;
		box-sizing: border-box;
		margin-bottom: 50px;
    }
</style>
